<template>
  <div id="footer" class="wrap">
    <div class="footer-bottom">
      <p class="desc-mul comm-wrap">
        <span class="desc-item long">浙江省(杭州良渚新城)知识产权服务业集聚发展示范区</span>
        <span class="desc-item">建设单位: 杭州良渚新城管理委员会</span>
        <span class="desc-item">归口管理: 杭州市市场监督管理局</span>
      </p>
      <div class="comm-wrap">
        <p class="desc-item full">杭州市知识产权公共服务平台余杭分平台(良渚新城)良渚新城知识产权公共服务平台</p>
      </div>
      <!-- 联系 -->
      <div class="footer-concat comm-wrap">
        <span class="desc">联系地址: 中国(良渚)数字文化社区1幢2楼企业一站式服务大厅(余杭区良渚街道网周路99号)</span>
        <span class="desc">联系电话: 0571-88777855</span>
        <span class="desc">服务邮箱: hzyyyw@hzyyip.com.cn</span>
      </div>
      <div class="footer-concat comm-wrap">
        <span class="desc">版权所有: 杭州良渚产业投资有限公司</span>
        <span class="desc">©2026 良渚新城知识产权公共服务平台</span>
        <span class="desc">浙公网安备 33011002018846号</span>
        <span class="desc">网站备案号: 浙ICP备2023011709号-3</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
    };
  }
};
</script>
<style scoped>
#footer {
  flex-shrink: 0;
  width: 100%;
  color: #fff;
  background: #fff;
  overflow: hidden;
  text-align: center;
}

.desc-item {
  padding-left: 30px;
  padding-right: 30px;
  height: 46px;
  font-size: 14px;
  line-height: 46px;
  background: #2262B3;
  /* 新增：防止desc-item内文本溢出 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.desc-item.long {
  padding-left: 130px;
  padding-right: 130px;
}
.desc-item.full {
  margin-top: 14px;
  margin-bottom: 30px;
  width: 100%;
  /* 重置full项的换行规则，允许换行 */
  white-space: normal;
  height: auto;
  line-height: 1.5;
  padding: 10px 0;
  background: transparent;
}

/* 核心修改：解决联系地址溢出问题 */
.footer-concat {
  /* 移除固定height，让容器自适应文本高度 */
  /* height: 28px; */
  line-height: 1.5; /* 调整行高，适配换行 */
  font-size: 14px;
  margin-bottom: 15px; /* 增加块间距，避免拥挤 */
}
.footer-concat .desc {
  margin-right: 20px; /* 减小右侧间距，避免溢出 */
  display: inline-block;
  /* 关键：设置文本换行规则 */
  word-wrap: break-word; /* 长单词换行 */
  word-break: break-all; /* 强制换行，适配中文 */
  vertical-align: top; /* 对齐方式优化 */
  max-width: calc(100% - 40px); /* 限制最大宽度，防止超出容器 */
}

.footer-bottom {
  padding-top: 20px;
  padding-bottom: 20px;
  /* 移除固定height，让footer高度自适应 */
  /* height: 240px; */
  background: linear-gradient(180deg, #185AAE 0%, #185AAE 100%);
}

.desc-mul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; /* 新增：小屏幕下desc-mul内的item自动换行 */
}

/* 原有样式保留 */
.logo {
  margin-right: 30px;
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

/* 响应式优化：小屏幕下进一步适配 */
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
  /* 小屏幕下调整footer样式 */
  .desc-item {
    width: 100%; /* 每个desc-item占满一行 */
    margin-bottom: 5px;
    white-space: normal; /* 允许换行 */
    height: auto;
    line-height: 1.5;
    padding: 10px 0;
  }
  .desc-item.long {
    padding-left: 20px;
    padding-right: 20px;
  }
  .footer-concat .desc {
    margin-right: 10px;
    margin-bottom: 8px; /* 增加上下间距 */
    font-size: 12px; /* 减小字体 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue